import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { useTracker } from '../../../../../context/hooks';
import { SeoRecommendations } from '../../../../constants';
import { RecommendationBaseView } from '../../../../sharedComponents/RecommendationBaseView';
import { jsx as _jsx } from "react/jsx-runtime";
export const AddTopicPhraseToTitleView = ({
  auditResult
}) => {
  const {
    track
  } = useTracker();
  const {
    status,
    topicPhrase
  } = auditResult;
  const handleClickKBLink = event => {
    track('clickedLearnMoreLink', {
      recommendationType: SeoRecommendations.ADD_TOPIC_PHRASE_TO_TITLE,
      linkAddress: event.currentTarget.href
    });
  };
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.ADD_TOPIC_PHRASE_TO_TITLE",
      options: {
        topicPhrase
      }
    }),
    description: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.ADD_TOPIC_PHRASE_TO_TITLE",
      options: {
        link: /*#__PURE__*/_jsx(Link, {
          href: "https://knowledge.hubspot.com/articles/kcs_article/content-strategy/pillar-pages-topics-and-subtopics#topic",
          external: true,
          onClick: handleClickKBLink,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "xray-recommendation-lib.seo.recommendations.linkText.ADD_TOPIC_PHRASE_TO_TITLE"
          })
        })
      }
    }),
    status: status
  });
};